import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

export enum OrchestrationScheduleType {
  AdHoc = 'ad-hoc',
  Scheduled = 'scheduled',
}

export interface OrchestartionRunName {
  scheduleType: OrchestrationScheduleType;
  scheduledPath?: string;
}

export const AD_HOC_HUMAN_READABLE = 'Ad hoc';

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-run-name',
  templateUrl: './orchestration-run-name.component.html',
  styleUrls: ['./orchestration-run-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationRunNameComponent {
  readonly AdHocHumanReadable = AD_HOC_HUMAN_READABLE;

  @Input() nameConfig?: OrchestartionRunName;
}
